const ModalInfo = function ()
{

    const modalInfo = function (el) 
    {
        const _this         = el;
        const _parent       = _this.closest('.wrap-resumo-apto');

        let infoTitle       = _parent.find('[data-title]').text();
        let infoQuartos     = _parent.find('[data-quartos]').text();
        let infoPessoas     = _parent.find('[data-pessoas]').text();
        let infoCamas       = _parent.find('[data-camas]').text();
        let infoBanheiros   = _parent.find('[data-banheiros]').text();
        let infoPossui      = _parent.find('.data-possui').html();

        console.log(infoPossui);

        // alimentando modal
        const _modalInfos = $('#modal-infos');

        _modalInfos.find("#info-title").html(infoTitle);
        _modalInfos.find("#info-quartos").html(infoQuartos);
        _modalInfos.find("#info-pessoas").html(infoPessoas);
        _modalInfos.find("#info-camas").html(infoCamas);
        _modalInfos.find("#info-banheiros").html(infoBanheiros);
        _modalInfos.find("#info-possui").html(infoPossui);

    }

    return {
        init : function () {

            $(".modal-info").on("click", function(){
                modalInfo( $(this) );
            });

        }
    }

}();

module.exports = ModalInfo;